"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalConfigContext = exports.getGlobalConfig = void 0;
/**
 * Get a copy of the global config object.
 */
exports.getGlobalConfig = function () {
    var namespace = typeof window !== 'undefined' && window.EPC || {};
    var globalConfig = namespace.GlobalConfig || {};
    return Object.freeze(Object.assign({}, globalConfig));
};
/**
 * Get a copy of the context object within the global config.
 */
exports.getGlobalConfigContext = function () {
    var globalConfig = exports.getGlobalConfig();
    var context = globalConfig.context || {};
    return Object.freeze(Object.assign({}, context));
};
